import { motion } from "framer-motion";

const TESTIMONIALS = [
  {
    quote:
      "I handed my entire content calendar to a single prompt from the guide and got my Sundays back. It genuinely feels like having a very chic assistant.",
    name: "Simone R.",
    role: "Creator & boutique owner",
    featured: true,
  },
  {
    quote:
      "I'd been intimidated by AI for two years. January explains it like a friend over champagne — soft, clear, and never condescending.",
    name: "Aaliyah M.",
    role: "Marketing consultant",
  },
  {
    quote:
      "The Sunday reset prompts alone were worth the $27. My inbox, my meal plan, my week — all quietly handled.",
    name: "Danielle T.",
    role: "Mother of two, nurse",
  },
];

const ease = [0.16, 1, 0.3, 1];

function Quote({ quote, name, role, featured, index }) {
  return (
    <motion.figure
      initial={{ opacity: 0, y: 32 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 1.2, delay: index * 0.15, ease }}
      className={featured ? "md:col-span-7" : "md:col-span-5"}
      data-testid={`testimonial-${index}`}
    >
      <span
        aria-hidden
        className="font-serif italic font-light leading-none block text-6xl md:text-7xl"
        style={{ color: "#C28C55" }}
      >
        &ldquo;
      </span>
      <blockquote
        className={`font-serif font-light leading-[1.2] -mt-6 ${
          featured ? "text-3xl md:text-4xl lg:text-5xl" : "text-2xl md:text-3xl"
        }`}
        style={{ color: "#FAF9F6" }}
      >
        {quote}
      </blockquote>
      <figcaption className="mt-8 flex items-center gap-4">
        <span className="gold-hair" style={{ width: 32 }} />
        <span className="text-sm" style={{ color: "#FAF9F6" }}>
          {name}
          <span className="block text-xs tracking-[0.25em] uppercase mt-1" style={{ color: "rgba(250,249,246,0.5)" }}>
            {role}
          </span>
        </span>
      </figcaption>
    </motion.figure>
  );
}

export default function Testimonials() {
  const [first, ...rest] = TESTIMONIALS;
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="py-24 md:py-40 px-6 md:px-12 lg:px-20 grain overflow-hidden"
      style={{ background: "#1A1A1A" }}
    >
      <div className="max-w-[1400px] mx-auto relative z-[2]">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 1.2, ease }}
          className="md:flex md:items-end md:justify-between gap-10"
        >
          <div>
            <span className="overline" data-testid="testimonials-overline">Kind Words</span>
            <h2 className="font-serif font-light text-4xl md:text-5xl lg:text-6xl mt-6 leading-[1.05]" style={{ color: "#FAF9F6" }}>
              From women living <em style={{ color: "#C28C55" }}>softer</em>.
            </h2>
          </div>
          <p className="mt-6 md:mt-0 max-w-xs text-sm leading-relaxed" style={{ color: "rgba(250,249,246,0.55)" }}>
            Notes from readers of The Soft Life AI Guide — shared with permission, edited only for length.
          </p>
        </motion.div>

        <div className="mt-16 md:mt-24 grid grid-cols-1 md:grid-cols-12 gap-14 md:gap-x-20 md:gap-y-24 items-start">
          <Quote {...first} index={0} />
          <div className="md:col-span-5 md:pt-32 flex flex-col gap-20">
            {rest.map((t, i) => (
              <Quote key={t.name} {...t} index={i + 1} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
